module.exports = __webpack_public_path__ + "img/Gasfles-verankeren_verplicht.2dd4b510.jpg";